import styled from '@emotion/styled';
import { Text } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { motion } from 'framer-motion';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

/*
 * 슬라이드 영역(ContentWrapper) 기준 플로팅 힌트 칩의 배치 앵커.
 * - 데스크톱: 좌상단. 우상단 툴바(TopRightWrapper), 하단 네비(BottomNavWrapper),
 *   CTA 버튼 레이어, 좌측 엣지 핸들(top 50%)과 모두 겹치지 않는 빈 코너다.
 * - 모바일: 상단 중앙. 하단 고정 컨트롤(NavPill/DrawerWrapper)과 썸네일 스트립
 *   개폐에 따른 bottomOffset 변화의 영향을 받지 않는다. 가로 모드에서 우상단으로
 *   올라오는 드로어를 피하도록 max-width를 제한한다.
 * - 배치 요소와 애니메이션 요소를 분리한다. framer-motion이 inline transform을
 *   소유하므로 translateX(-50%)를 motion 요소에 두면 덮어써진다.
 */
export const ChipAnchor = styled.div<{ isMobile: boolean }>`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.hintChip};
  display: flex;
  justify-content: center;

  /* 칩 바깥 여백이 슬라이드 클릭/스와이프를 가로채지 않게 한다 */
  pointer-events: none;

  ${({ isMobile }) =>
    isMobile
      ? `
        top: 12px;
        left: 50%;
        max-width: calc(100% - 120px);
        transform: translateX(-50%);
      `
      : `
        top: 24px;
        left: 24px;
        max-width: calc(100% - 48px);
      `}
`;

export const Chip = styled(motion.div)`
  display: flex;
  min-width: 0;
  align-items: center;
  padding: 4px;
  border: 1px solid ${theme.colors.zinc_200};
  background: ${theme.colors.white};
  border-radius: 9999px;
  box-shadow: ${theme.elevation.sm};
  gap: 4px;
  pointer-events: auto;

  &.disabled {
    cursor: initial;
  }
`;

export const ChipAction = styled.button`
  display: flex;
  min-width: 0;
  align-items: center;
  padding: 4px 8px;
  border: none;
  background: transparent;
  border-radius: 9999px;
  cursor: pointer;
  gap: 6px;
  transition: 0.15s ease-in-out;

  &:hover {
    background: ${theme.colors.zinc_100};
  }
`;

export const ChipLabel = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ChipClose = styled.button`
  display: flex;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  border-radius: 9999px;
  cursor: pointer;
  transition: 0.15s ease-in-out;

  &:hover {
    background: ${theme.colors.zinc_100};
  }
`;
